export async function clear(prefix?: string): Promise<any> {
  prefix = prefix || '';
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i);
    if (!k) continue;
    if (k.startsWith(prefix)) localStorage.removeItem(k);
  }
}
